import { useTranslation } from "react-i18next";

export function useLinkTypeList() {
    const { t } = useTranslation();

    const dmsFluxList = [
        "FLATFILES",
        "API"
    ]

    let result: { value: string, label: string }[] = [];

    dmsFluxList.forEach(dmsFlux => {
        result = [
            ...result,
            {
                value: dmsFlux,
                label: t(`Account.DmsFluxPG.${dmsFlux}`)
            }
        ]
    })

    return result
}